import { useParams, Link } from 'react-router-dom';
import { Button } from '../components/ui/button';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '../components/ui/tabs';
import { ArrowLeft } from 'lucide-react';
import ImageEditorPage from './ImageEditorPage';
import ImageOverlaysPage from './ImageOverlaysPage';

export default function ImagesPage() {
  const { projectId } = useParams();
  return (
    <div className="p-6 lg:p-8">
      <div className="flex items-center gap-4 mb-6">
        <Button asChild variant="ghost" size="icon" data-testid="back-btn">
          <Link to={`/projects/${projectId}`}><ArrowLeft className="w-5 h-5" /></Link>
        </Button>
        <div className="flex-1">
          <h1 className="text-2xl font-heading font-bold text-slate-900">Obrázky</h1>
          <p className="text-sm text-slate-500">Hlavní fotka produktu a overlay přes fotky</p>
        </div>
      </div>
      <Tabs defaultValue="main" className="space-y-6">
        <TabsList className="bg-slate-100">
          <TabsTrigger value="main" data-testid="tab-main-images">Hlavní fotky</TabsTrigger>
          <TabsTrigger value="overlay" data-testid="tab-overlay">Overlay</TabsTrigger>
        </TabsList>
        <TabsContent value="main"><ImageEditorPage embedded /></TabsContent>
        <TabsContent value="overlay"><ImageOverlaysPage embedded /></TabsContent>
      </Tabs>
    </div>
  );
}
